import Add from '@mui/icons-material/Add';
import { Box, Button, Checkbox, Stack, Typography } from '@mui/joy';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '../../components/core/Loader';
import { NoData } from '../../components/nodata';
import { useUser } from '../../hooks/useUser';
import { UpcomingEvents } from '../homepage/upcomingEvents';
import EventCard from './eventCard';

const MainEventsContent = (props: any) => {
  const { events, setSelectedEvent, setShowModal } = props;
  const [showPastEvents, setShowPastEvents] = useState(false);
  const { t } = useTranslation();
  const userQuery = useUser();

  if (!userQuery.isSuccess) {
    return <Loader />;
  }

  const isAdmin =
    userQuery.data.role === 'ADMIN' || userQuery.data.role === 'SUPER_ADMIN';

  let filteredEvents = events.filter((event: any) => {
    // Past events are not included
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const eventDate = new Date(event.dateStart);
    eventDate.setHours(0, 0, 0, 0);
    const eventHasStarted = today > eventDate;

    if (showPastEvents){
      // If past events are shown, only show events that have ended
      return eventHasStarted;
    }

    if (!showPastEvents) {
      // If not past events, only show events that have not started yet
      return !eventHasStarted;
    }

    return [null, undefined, 'default'].indexOf(event.type) >= 0;
  })
  

  if (showPastEvents){
    // Sort most recent past events first
    filteredEvents = filteredEvents.sort((a: any, b: any) => {
      const dateA = new Date(a.dateStart);
      const dateB = new Date(b.dateStart);
      return dateB.getTime() - dateA.getTime();
    });
  }

  if (!showPastEvents) {
    // Sort upcoming events by start date
    filteredEvents = filteredEvents.sort((a: any, b: any) => {
      const dateA = new Date(a.dateStart);
      const dateB = new Date(b.dateStart);
      return dateA.getTime() - dateB.getTime();
    }); 
  }

  return (
    <>
      <Box display={{ xs: 'block', lg: 'none' }}>
        <UpcomingEvents onlyShowFirstOnMobile={false} />
      </Box>
      <Stack spacing={3} display={{ xs: 'none', lg: 'block' }}>
        {/* Title */}
        <Typography level="h1"> {t('events.events')}</Typography>

        <Stack direction="row" spacing={2}>
          {/* Create button */}
          {isAdmin && (
            <Button
              variant="solid"
              startDecorator={<Add />}
              onClick={setShowModal}
            >
              Event aanmaken
            </Button>
          )}
          <Checkbox
            label="Toon afgelopen evenementen"
            onChange={() => setShowPastEvents(!showPastEvents)}
            checked={showPastEvents}
          />
        </Stack>

        {/* No topics placeholder */}
        {!filteredEvents.length && (
          <div className="w-full flex justify-center pt-[150px]">
            <NoData />
          </div>
        )}

        {/* List of events */}
        <ul className="grid lg:grid-cols-2 gap-5">
          {filteredEvents.map((event: any) => {
            return (
              <EventCard
                key={event._id}
                title={event.title}
                description={event.description}
                members={event.attendees.length}
                updateEvent={() => {}}
                onClickEdit={() => {
                  setSelectedEvent(event);
                  setShowModal(true);
                }}
                id={event._id}
                image={event.imageUrl}
                isAdmin={isAdmin}
                joined={false}
                dateEnd={event.dateEnd}
                dateStart={event.dateStart}
                timeStart={event.timeStart}
              />
            );
          })}
        </ul>
      </Stack>
    </>
  );
};

export default MainEventsContent;
